import React from "react";

//STYLES
import * as HomeStyles from "../styles/home";

function Home() {
    return (
        <div style={HomeStyles.body}>
            <h1>Development Hub</h1>
            <h2>Pick a Pod to test!</h2>
        </div>
    );
}

export default Home;
